var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "client_request_btn shadow-sm" }, [
    _c(
      "button",
      { staticClass: "btn btn-outline-info", on: { click: _vm.openDrawer } },
      [_c("i", { staticClass: "icon-fa icon-fa-user-plus" })]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }